import { render, staticRenderFns } from "./EducatorEdit.vue?vue&type=template&id=7ff3b8f4"
import script from "./EducatorEdit.vue?vue&type=script&lang=ts"
export * from "./EducatorEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports